//export const API_URL = "http://localhost:3001/";
//export const API_URL = "http://devadmin.tennis24.it/";
//export const API_URL = "https://admin.tennis24.it/";

export const ACCESS_TOKEN = "access_token";

export const DOMINIO_ADMIN = "admin";

const DEV_API_URL = "http://localhost:3001/"; //url dell'api quando gira in ambiente locale dev di lorenzo o di chiunque altro
const PROD_API_URL = "https://admin.tennis24.it/"; //url dell'api BACKEND quando gira in ambiente di produzione, è l'url su cui il frontend deve fare le chiamate
//ad esempio nell'ambiente di test interno deepnet
//const DEV_API_URL = "https://admin.tennis24.local/";
//const PROD_API_URL = "https://admin.tennis24.local/";

export const API_URL = process.env.NODE_ENV === "development" ? DEV_API_URL : PROD_API_URL;
